import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.3.2_@babel+core@7.27.1_react-dom@19.1.0_react@19.1.0__react@19.1.0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/loader/style.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/assets/icons/zenhr/home/1-o-1-meetings-image.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/assets/icons/zenhr/home/ai-driven-insight-image.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/assets/icons/zenhr/home/attendance-management-image.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/assets/icons/zenhr/home/automated-onbaording-offboarding-image.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/assets/icons/zenhr/home/centralized-hr-data-image.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/assets/icons/zenhr/home/comments.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/assets/icons/zenhr/home/conversational-ai-image.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/assets/icons/zenhr/home/creditcard-flash.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/assets/icons/zenhr/home/data-driven-insight-image.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/assets/icons/zenhr/home/document-management-image.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/assets/icons/zenhr/home/employee-directory-image.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/assets/icons/zenhr/home/goal-setting-image.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/assets/icons/zenhr/home/hero-image.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/assets/icons/zenhr/home/leave-management-image.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/assets/icons/zenhr/home/offboarding-image.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/assets/icons/zenhr/home/offboarding-mobile-image.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/assets/icons/zenhr/home/onboarding-image.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/assets/icons/zenhr/home/onboarding-mobile-image.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/assets/icons/zenhr/home/passport-2.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/assets/icons/zenhr/home/performance-cycle-image.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/assets/icons/zenhr/home/real-time-updates-image.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/assets/icons/zenhr/home/streamlined-access-image.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/assets/icons/zenhr/home/transitions-image.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/assets/icons/zenhr/home/transitions-mobile-image.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/assets/icons/zenhr/home/user-tie.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/assets/icons/zenhr/home/users-group-2.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/v1/common-components/navigation/Navigation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/v1/common-components/page-layout/PageLayout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/v1/common-components/vertical-carousel/VerticalCarousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/v1/page-components/zenhr/home/automation-and-ai/AutomationAndAI.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/v1/page-components/zenhr/home/hero/Hero.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/page-components/zenhr/home/main/styles.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/page-components/zenhr/home/hr-services/styles.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/v1/page-components/zenhr/home/onboarding-and-offboarding/OnboardingAndOffboarding.tsx");
